import { PatchContactOwnerFormQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchContactOwnerForm/patchContactOwnerFormQuery.type';
import { patchContactOwnerFormFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchContactOwnerForm/patchContactOwnerFormQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchContactOwnerFormQueryOptions = () => {
  return useMutation({
    mutationKey: ['ContactOwnerFormQuery'],
    mutationFn: (params: PatchContactOwnerFormQueryParamsType) =>
      patchContactOwnerFormFunction(params),
  });
};
